define(
    'modals/secured/help/SetupGuideModal',[
        "plugins/dialog",
        "services/session",
        "i19n!i19n/strings",
        "services/session",
        "viewmodels/secured/help/guided/usingThisGuide",
        "viewmodels/secured/help/guided/gettingStarted",
        "viewmodels/secured/help/guided/addPeople",
        "viewmodels/secured/help/guided/createLibraries",
        "viewmodels/secured/help/guided/importDocuments",
        "viewmodels/secured/help/guided/setAccessControl",
        "viewmodels/secured/help/guided/nextSteps",
    ],
    function (dialog, session, i19n, session, usingThisGuide, gettingStarted, addPeople, createLibraries, importDocuments, setAccessControl, nextSteps) {

        function Modal() {
            var self = this;

            self.i19n = i19n;
            self.session = session;
            self.nextText = ko.observable(i19n.to.next);
            self.close.visible = ko.observable(true);

            var topic = null;

            var id = window.localStorage.getItem("guidedHelp:topic");

            if (!id || id == 0) topic = usingThisGuide;
            if (!(!id) && id == 1) topic = gettingStarted;
            if (!(!id) && id == 2) topic = addPeople;
            if (!(!id) && id == 3) topic = createLibraries;
            if (!(!id) && id == 4) topic = importDocuments;
            if (!(!id) && id == 5) topic = setAccessControl;
            if (!(!id) && id == 6) topic = nextSteps;

            self.topic = ko.observable(topic);

            if (id == 6) {
                self.nextText(i19n.to.finish);
                self.close.visible(false);
            }
        }

        Modal.prototype.activate = function () {
        };

        Modal.prototype.close = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                var self = this;

                dialog.close(self, { close: true });

                complete();
            }
        });

        Modal.prototype.next = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                var self = this;

                complete();

                if (self.topic().id == "0") {
                    self.gettingStarted();
                } else if (self.topic().id == "1") {
                    self.addPeople();
                } else if (self.topic().id == "2") {
                    self.createLibraries();
                } else if (self.topic().id == "3") {
                    self.importDocuments();
                } else if (self.topic().id == "4") {
                    self.setAccessControl();
                } else if (self.topic().id == "5") {
                    self.nextSteps();
                } else if (self.topic().id == "6") {
                    dialog.close(self, { close: true });
                }
            }
        });

        Modal.prototype.usingThisGuide = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                var self = this;

                self.nextText(i19n.to.next);
                self.close.visible(true);

                self.topic(usingThisGuide);

                window.localStorage.setItem("guidedHelp:topic", self.topic().id);

                complete();
            }
        });
        Modal.prototype.gettingStarted = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                var self = this;

                self.nextText(i19n.to.next);

                self.topic(gettingStarted);

                window.localStorage.setItem("guidedHelp:topic", self.topic().id);

                complete();
            }
        });
        Modal.prototype.addPeople = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                var self = this;

                self.nextText(i19n.to.next);
                self.close.visible(true);

                self.topic(addPeople);

                window.localStorage.setItem("guidedHelp:topic", self.topic().id);

                complete();
            }
        });
        Modal.prototype.createLibraries = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                var self = this;

                self.nextText(i19n.to.next);
                self.close.visible(true);

                self.topic(createLibraries);

                window.localStorage.setItem("guidedHelp:topic", self.topic().id);

                complete();
            }
        });
        Modal.prototype.importDocuments = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                var self = this;

                self.nextText(i19n.to.next);
                self.close.visible(true);

                self.topic(importDocuments);

                window.localStorage.setItem("guidedHelp:topic", self.topic().id);

                complete();
            }
        });
        Modal.prototype.setAccessControl = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                var self = this;

                self.nextText(i19n.to.next);
                self.close.visible(true);

                self.topic(setAccessControl);

                window.localStorage.setItem("guidedHelp:topic", self.topic().id);

                complete();
            }
        });
        Modal.prototype.nextSteps = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                var self = this;

                self.nextText(i19n.to.finish);
                self.close.visible(false);

                self.topic(nextSteps);

                window.localStorage.setItem("guidedHelp:topic", self.topic().id);

                complete();
            }
        });

        return Modal;
    }
);
